import { render, staticRenderFns } from "./index.vue?vue&type=template&id=55bdcad6&scoped=true&lang=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55bdcad6",
  null
  
)

export default component.exports